import React from 'react';
import './App.css';

import "react-datepicker/dist/react-datepicker.css";

import Header from './Header/Header';
import { Route, Switch } from 'react-router-dom';
import LassaFever from './LassaFever/LassaFever';
import Login from './Login/Login';
import Reguser from './Reg/Reg';
import Covid from './Covid/Covid';
import Dashboard from './Dashboard/dashboard';
import My404page from './Errors/404page';
import Malaria from './Malaria/Malaria';
import { useEffect } from 'react';
import {Context as CasesContext} from './Context/CasesContext'
import { useContext } from 'react';



//https://covid19.mathdro.id/api

function App() {

const { fetchMalaria, fetchLassa} = useContext(CasesContext)

useEffect(() => {
  fetchLassa()
  fetchMalaria()
}, [])


 
  return (
    <div className="App">
      <Header />
      <Switch>
      <Route path='/malaria' exact component={Malaria} />
      <Route path='/lassa-fever' exact component={LassaFever} />
      <Route path='/login' exact component={Login} />
      <Route path='/adminreg' exact component={Reguser} />
      <Route path='/dashboard' component={Dashboard} /> 
      <Route path='/' exact component={Covid} />
      <Route path='*' exact component={My404page} />
      </Switch>

    </div>
  );
}

export default App;